export default __webpack_public_path__ + "static/vera-b9019d00c1d489f418d9118cfd5a4cd9.jpg";